import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../store/root-reducer';
import ModifyDialerSubscription from './modify-dialer-subscription';
import {
  getConnectedUsersAndEmailAccountsRequest,
  applyCouponCodeRequest,
  upgradePlanRequest,
  downgradePlanRequest,
  upgradeLtdPlanRequest,
  modifyLtdPlanRequest,
  getDialerPlansRequest,
  getDialerSubscriptionRequest,
  purchaseDialerModifySubscriptionRequest,
} from '../../extra-actions';
import {
  ApplyCouponCodeRequest,
  UpgradePlanRequest,
  DowngradePlanRequest,
  LTDUpgradePayload,
  LTDModifyPayload,
} from '../../types';
import { PaddleUpgradeSubscriptionRequest } from '../../types/paddle';
import {
  deleteAppliedCouponCode,
  resetConnectedUsersAndEmailAccountsRequest,
  resetPurchaseDialerModifySubscriptionResponse,
  resetPurchaseModifySubscriptionResponse,
  selectPlan,
} from '../../billing-subscription-slice';

const mapStateToProps = (state: RootState) => ({
  sendGetDialerSubscriptionRequestStatus:
    state.billingAndSubscription.getDialerSubscriptionRequest.status,
  sendGetDialerSubscriptionRequestError:
    state.billingAndSubscription.getDialerSubscriptionRequest.error,
  sendGetDialerPlansRequestStatus:
    state.billingAndSubscription.getDialerPlansRequest.status,
  sendGetDialerPlansRequestError:
    state.billingAndSubscription.getDialerPlansRequest.error,
  sendGetDialerSubscriptionResponse:
    state.billingAndSubscription.getDialerSubscriptionResponse,
  sendGetConnectedUsersAndEmailAccountsRequestStatus:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsRequest
      .status,
  sendGetConnectedUsersAndEmailAccountsRequestError:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsRequest.error,
  sendGetConnectedUsersAndEmailAccountsRequestResponse:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsResponse,
  sendApplyCouponCodeRequestStatus:
    state.billingAndSubscription.applyCouponCodeRequest.status,
  sendApplyCouponCodeRequestMessage:
    state.billingAndSubscription.applyCouponCodeRequest.message,
  sendApplyCouponCodeRequestError:
    state.billingAndSubscription.applyCouponCodeRequest.error,
  getCouponCodeResponse: state.billingAndSubscription.applyCouponCodeResponse,
  sendGetPurchaseDialerModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseDialerModifySubscriptionRequest.status,
  sendGetModifySubscriptionResponse:
    state.billingAndSubscription.modifySubscriptionResponse,
  selectedPlanDetails: state.billingAndSubscription.selectedPlanDetails,

  upgradeLtdPlanRequestStatus:
    state.billingAndSubscription.upgradeLtdPlanRequest.status,
  upgradeLtdPlanRequestError:
    state.billingAndSubscription.upgradeLtdPlanRequest.error,
  modifyLtdPlanRequestStatus:
    state.billingAndSubscription.modifyLtdPlanRequest.status,
  modifyLtdPlanRequestError:
    state.billingAndSubscription.modifyLtdPlanRequest.error,

  userCurrentPlan: state.home.subscription?.planCode,
  subscriptionPlanStatus: state.home.subscription?.status,

  sendGetDialerPlansResponse:
    state?.billingAndSubscription?.getDialerPlansResponse,
});

const mapDispatchToProps = {
  sendGetDialerSubscriptionRequest: () => getDialerSubscriptionRequest(),
  sendGetDialerPlansRequest: () => getDialerPlansRequest(),
  sendApplyCouponCodeRequest: (payload: ApplyCouponCodeRequest) =>
    applyCouponCodeRequest(payload),
  sendGetConnectedUsersAndEmailAccountsRequest: () =>
    getConnectedUsersAndEmailAccountsRequest(),
  resetConnectedUsersAndEmailAccountsRequest: () =>
    resetConnectedUsersAndEmailAccountsRequest(),
  deleteAppliedCouponCode: () => deleteAppliedCouponCode(),
  sendPurchaseDialerModifySubscriptionRequest: (
    payload: PaddleUpgradeSubscriptionRequest,
  ) => purchaseDialerModifySubscriptionRequest(payload),
  resetPurchaseDialerModifySubscriptionResponse: () =>
    resetPurchaseDialerModifySubscriptionResponse(),
  resetPurchaseModifySubscriptionResponse: () =>
    resetPurchaseModifySubscriptionResponse(),
  sendUpgradePlanRequest: (payload: UpgradePlanRequest) =>
    upgradePlanRequest(payload),
  sendDowngradePlanRequest: (payload: DowngradePlanRequest) =>
    downgradePlanRequest(payload),
  selectPlan: (payload) => selectPlan(payload),
  hideLoading: () => hideLoading(),
  showLoading: () => showLoading(),

  sendUpgradeLtdPlanRequest: (payload: LTDUpgradePayload) =>
    upgradeLtdPlanRequest(payload),

  sendModifyLtdPlanRequest: (payload: LTDModifyPayload) =>
    modifyLtdPlanRequest(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export type LocationStateType = {
  isModifySubscription: boolean;
};

export default connector(ModifyDialerSubscription);
